import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=db879c22&scoped=true"
import script from "./UploadBtn.vue?vue&type=script&lang=js"
export * from "./UploadBtn.vue?vue&type=script&lang=js"
import style0 from "./UploadBtn.vue?vue&type=style&index=0&id=db879c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db879c22",
  null
  
)

export default component.exports